import './firebase'
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import VueFirestore from 'vue-firestore'
import { router } from './routes'
import App from './App'
import bootstrap from 'bootstrap'

import fontawesome from '@fortawesome/fontawesome'
import FontAwesome from '@fortawesome/vue-fontawesome'
import light from '@fortawesome/fontawesome-pro-light'

import Notifications from './components/Notifications'

fontawesome.library.add(light)

Vue.use(VeeValidate)
Vue.use(VueFirestore)

Vue.component('font-awesome-icon', FontAwesome)
Vue.component('notifications', Notifications)

Vue.config.productionTip = false;

new Vue({
	el: '#app',
  router,
  components: { App },
  template: '<App />'
})



// WEBPACK FOOTER //
// ./src/main.js